import childrenHome from '@/assets/images/products/children/Nivi蛋正面.webp'
import childrenTechnology from '@/assets/images/products/children/Nivi蛋三视图.webp'
import childrenHomeSingle from '@/assets/images/products/home/nivi-egg-single-v2.webp'
import robotLifeStationHomeSingle from '@/assets/images/products/home/nivi-robot-life-station-single-v2.webp'
import dogHomeGuardHomeSingle from '@/assets/images/products/home/nivi-dog-home-guard-single-v2.webp'
import robotGarmentScene from '@/assets/images/products/robot/robot-garment-scene.webp'
import robotGarmentSceneMobile from '@/assets/images/products/robot/robot-garment-scene-mobile.webp'
import robotGarmentSingle from '@/assets/images/products/robot/robot-garment-single.webp'
import robotGarmentSingleMobile from '@/assets/images/products/robot/robot-garment-single-mobile.webp'
import robotCareScene from '@/assets/images/products/robot/robot-care-scene.webp'
import robotCareSceneMobile from '@/assets/images/products/robot/robot-care-scene-mobile.webp'
import robotCareSingle from '@/assets/images/products/robot/robot-care-single.webp'
import robotCareSingleMobile from '@/assets/images/products/robot/robot-care-single-mobile.webp'
import robotCateringScene from '@/assets/images/products/robot/robot-catering-scene.webp'
import robotCateringSceneMobile from '@/assets/images/products/robot/robot-catering-scene-mobile.webp'
import robotCateringSingle from '@/assets/images/products/robot/robot-catering-single.webp'
import robotCateringSingleMobile from '@/assets/images/products/robot/robot-catering-single-mobile.webp'
import robotRetailScene from '@/assets/images/products/robot/robot-retail-scene.webp'
import robotRetailSceneMobile from '@/assets/images/products/robot/robot-retail-scene-mobile.webp'
import robotRetailSingle from '@/assets/images/products/robot/robot-retail-single.webp'
import robotRetailSingleMobile from '@/assets/images/products/robot/robot-retail-single-mobile.webp'
import robotAssemblyScene from '@/assets/images/products/robot/robot-assembly-scene.webp'
import robotAssemblySceneMobile from '@/assets/images/products/robot/robot-assembly-scene-mobile.webp'
import robotAssemblySingle from '@/assets/images/products/robot/robot-assembly-single.webp'
import robotAssemblySingleMobile from '@/assets/images/products/robot/robot-assembly-single-mobile.webp'
import robotMaintenanceScene from '@/assets/images/products/robot/robot-maintenance-scene.webp'
import robotMaintenanceSceneMobile from '@/assets/images/products/robot/robot-maintenance-scene-mobile.webp'
import robotMaintenanceSingle from '@/assets/images/products/robot/robot-maintenance-single.webp'
import robotMaintenanceSingleMobile from '@/assets/images/products/robot/robot-maintenance-single-mobile.webp'
import robotBreachScene from '@/assets/images/products/robot/robot-breach-scene.webp'
import robotBreachSceneMobile from '@/assets/images/products/robot/robot-breach-scene-mobile.webp'
import robotBreachSingle from '@/assets/images/products/robot/robot-breach-single.webp'
import robotBreachSingleMobile from '@/assets/images/products/robot/robot-breach-single-mobile.webp'
import robotTriageScene from '@/assets/images/products/robot/robot-triage-scene.webp'
import robotTriageSceneMobile from '@/assets/images/products/robot/robot-triage-scene-mobile.webp'
import robotTriageSingle from '@/assets/images/products/robot/robot-triage-single.webp'
import robotTriageSingleMobile from '@/assets/images/products/robot/robot-triage-single-mobile.webp'
import dogHomeGuardScene from '@/assets/images/products/dog/dog-home-guard-scene.webp'
import dogHomeGuardSceneMobile from '@/assets/images/products/dog/dog-home-guard-scene-mobile.webp'
import dogHomeGuardSingle from '@/assets/images/products/dog/dog-home-guard-single.webp'
import dogHomeGuardSingleMobile from '@/assets/images/products/dog/dog-home-guard-single-mobile.webp'
import dogPaceScene from '@/assets/images/products/dog/dog-pace-scene.webp'
import dogPaceSceneMobile from '@/assets/images/products/dog/dog-pace-scene-mobile.webp'
import dogPaceSingle from '@/assets/images/products/dog/dog-pace-single.webp'
import dogPaceSingleMobile from '@/assets/images/products/dog/dog-pace-single-mobile.webp'
import dogGuideScene from '@/assets/images/products/dog/dog-guide-scene.webp'
import dogGuideSceneMobile from '@/assets/images/products/dog/dog-guide-scene-mobile.webp'
import dogGuideSingle from '@/assets/images/products/dog/dog-guide-single.webp'
import dogGuideSingleMobile from '@/assets/images/products/dog/dog-guide-single-mobile.webp'
import dogDeliveryScene from '@/assets/images/products/dog/dog-delivery-scene.webp'
import dogDeliverySceneMobile from '@/assets/images/products/dog/dog-delivery-scene-mobile.webp'
import dogDeliverySingle from '@/assets/images/products/dog/dog-delivery-single.webp'
import dogDeliverySingleMobile from '@/assets/images/products/dog/dog-delivery-single-mobile.webp'
import dogLeakScene from '@/assets/images/products/dog/dog-leak-scene.webp'
import dogLeakSceneMobile from '@/assets/images/products/dog/dog-leak-scene-mobile.webp'
import dogLeakSingle from '@/assets/images/products/dog/dog-leak-single.webp'
import dogLeakSingleMobile from '@/assets/images/products/dog/dog-leak-single-mobile.webp'
import dogHaulScene from '@/assets/images/products/dog/dog-haul-scene.webp'
import dogHaulSceneMobile from '@/assets/images/products/dog/dog-haul-scene-mobile.webp'
import dogHaulSingle from '@/assets/images/products/dog/dog-haul-single.webp'
import dogHaulSingleMobile from '@/assets/images/products/dog/dog-haul-single-mobile.webp'
import dogSearchScene from '@/assets/images/products/dog/dog-search-scene.webp'
import dogSearchSceneMobile from '@/assets/images/products/dog/dog-search-scene-mobile.webp'
import dogSearchSingle from '@/assets/images/products/dog/dog-search-single.webp'
import dogSearchSingleMobile from '@/assets/images/products/dog/dog-search-single-mobile.webp'
import dogFireScoutScene from '@/assets/images/products/dog/dog-fire-scout-scene.webp'
import dogFireScoutSceneMobile from '@/assets/images/products/dog/dog-fire-scout-scene-mobile.webp'
import dogFireScoutSingle from '@/assets/images/products/dog/dog-fire-scout-single.webp'
import dogFireScoutSingleMobile from '@/assets/images/products/dog/dog-fire-scout-single-mobile.webp'
import dogSurveyTechnology from '@/assets/images/products/dog/dog-survey-tech.webp'
import dogSurveyTechnologyMobile from '@/assets/images/products/dog/dog-survey-tech-mobile.webp'
import ringRepresentative from '@/assets/images/products/ring/tm13-01.webp'

const responsive = (desktop, mobile) => ({ desktop, mobile })
const homeRepresentative = (image, alt) => ({ desktop: image, mobile: image, alt })

const deepFreeze = value => {
  Object.values(value).forEach(child => {
    if (child && typeof child === 'object' && !Object.isFrozen(child)) deepFreeze(child)
  })
  return Object.freeze(value)
}

const roleCategories = ['家庭生活', '商业服务', '工业作业', '公共安全与救援']

export const primaryProductSeries = deepFreeze([
  {
    id: 'children',
    name: 'Nivi蛋',
    type: 'children',
    positioning: '儿童情感陪伴与成长',
    technologyDescription: '陪伴蛋以语音、表情与日常互动承载情绪理解，让技术自然进入家庭陪伴。',
    route: '/products/children',
    media: {
      home: homeRepresentative(childrenHomeSingle, 'Nivi蛋完整产品单体'),
      overview: homeRepresentative(childrenHomeSingle, 'Nivi蛋完整产品单体'),
      technology: responsive(childrenTechnology, childrenTechnology),
      hero: responsive(childrenHome, childrenHome)
    }
  },
  {
    id: 'robot',
    name: 'Nivi机器人',
    type: 'robot',
    categories: roleCategories,
    positioning: '面向家庭、商业、工业与救援场景的通用人形服务平台',
    technologyDescription: '服务机器人将感知、理解与任务协作连接起来，适配家庭、商业和公共服务场景。',
    route: '/products/robot',
    media: {
      home: homeRepresentative(robotLifeStationHomeSingle, 'Nivi机器人生命站完整产品单体'),
      overview: homeRepresentative(robotLifeStationHomeSingle, 'Nivi机器人生命站完整产品单体'),
      technology: responsive(robotAssemblyScene, robotAssemblySceneMobile),
      hero: responsive(robotCareScene, robotCareSceneMobile)
    }
  },
  {
    id: 'dog',
    name: 'Nivi狗',
    type: 'dog',
    categories: roleCategories,
    positioning: '复杂地形巡检、运输与公共安全四足协作平台',
    technologyDescription: '机器狗结合环境感知与移动能力，为复杂地形中的巡检、运输和安全协作提供载体。',
    route: '/products/dog',
    media: {
      home: homeRepresentative(dogHomeGuardHomeSingle, 'Nivi狗宅哨完整产品单体'),
      overview: homeRepresentative(dogHomeGuardHomeSingle, 'Nivi狗宅哨完整产品单体'),
      technology: responsive(dogSurveyTechnology, dogSurveyTechnologyMobile),
      hero: responsive(dogHomeGuardScene, dogHomeGuardSceneMobile)
    }
  }
])

export const productSeries = deepFreeze([
  ...primaryProductSeries,
  {
    id: 'ring',
    name: 'ODOY智能戒指',
    type: 'ring',
    positioning: '贴近日常佩戴的健康感知与智能交互',
    technologyDescription: '智能戒指将健康感知、日常提醒与轻量交互融入持续佩戴体验。',
    route: '/products/ring',
    media: {
      home: homeRepresentative(ringRepresentative, 'ODOY智能戒指产品组合'),
      overview: homeRepresentative(ringRepresentative, 'ODOY智能戒指产品组合'),
      technology: responsive(ringRepresentative, ringRepresentative),
      hero: responsive(ringRepresentative, ringRepresentative)
    }
  }
])

const accentHexByName = Object.freeze({
  '珍珠白': '#f4f1e8',
  '浅灰': '#b9bec1',
  '紫色': '#7f6e9d',
  '暖白': '#f2eee5',
  '柔和灰': '#a9aaa5',
  '暖金色': '#b9975b',
  '不锈钢银': '#adb5b8',
  '深蓝': '#294a65',
  '青色': '#318c8c',
  '香槟银': '#c4b7a2',
  '钛灰': '#697379',
  '工程黄': '#e3b341',
  '橙色': '#d96c32',
  '工程橙': '#cf642c',
  '黑色': '#242626',
  '深灰': '#4b5154',
  '消防红': '#b8463c',
  '荧光黄': '#d8de42',
  '洁净白': '#f7f8f5',
  '医疗红': '#c94e51',
  '石墨灰': '#5a5d5e',
  '红橙色': '#d75b3f',
  '高可视黄': '#e1d339',
  '电光蓝': '#2786d7',
  '蓝绿色': '#27877f',
  '紫红色': '#9b4668',
  '耐火黑': '#272827'
})

const role = (data, desktopScene, mobileScene, desktopSingle, mobileSingle) => ({
  ...data,
  accentHex: data.accentColors.map(accent => accentHexByName[accent]),
  media: {
    desktopScene,
    mobileScene,
    desktopSingle,
    mobileSingle,
    aspectRatio: data.type === 'robot' ? 3 / 4 : 4 / 3
  }
})

export const roleProducts = deepFreeze([
  role({
    slug: 'robot-garment', name: '织序', type: 'robot', series: 'Nivi机器人', category: '家庭生活',
    primaryFunction: '衣物护理', positioning: '从洗后处理到收纳的衣物护理助手',
    features: ['面料识别', '衣物分类', '平整折叠', '局部蒸汽护理', '衣柜归位'],
    scenes: ['洗衣房', '衣帽间'], accentColors: ['珍珠白', '浅灰', '紫色']
  }, robotGarmentScene, robotGarmentSceneMobile, robotGarmentSingle, robotGarmentSingleMobile),
  role({
    slug: 'robot-care', name: '安澜', type: 'robot', series: 'Nivi机器人', category: '家庭生活',
    primaryFunction: '长者生活辅助', positioning: '面向长者日常起居的非医疗生活辅助',
    features: ['起身支撑', '步态陪护', '物品取放', '日程提醒', '异常呼叫'],
    scenes: ['住宅', '养老社区'], accentColors: ['暖白', '柔和灰', '暖金色']
  }, robotCareScene, robotCareSceneMobile, robotCareSingle, robotCareSingleMobile),
  role({
    slug: 'robot-catering', name: '餐阵', type: 'robot', series: 'Nivi机器人', category: '商业服务',
    primaryFunction: '餐饮制作服务', positioning: '面向商业后厨的标准化批量出餐单元',
    features: ['批量配料', '标准化烹制', '多工位协同', '出餐校验', '卫生自检'],
    scenes: ['餐厅', '食堂', '中央厨房'], accentColors: ['不锈钢银', '深蓝', '青色']
  }, robotCateringScene, robotCateringSceneMobile, robotCateringSingle, robotCateringSingleMobile),
  role({
    slug: 'robot-retail', name: '架衡', type: 'robot', series: 'Nivi机器人', category: '商业服务',
    primaryFunction: '零售补货陈列', positioning: '商场与仓店的高位补货陈列机器人',
    features: ['商品识别', '库存盘点', '高位取放', '货架陈列', '缺货上报'],
    scenes: ['零售门店', '仓储式商店'], accentColors: ['香槟银', '深蓝', '青色']
  }, robotRetailScene, robotRetailSceneMobile, robotRetailSingle, robotRetailSingleMobile),
  role({
    slug: 'robot-assembly', name: '精构', type: 'robot', series: 'Nivi机器人', category: '工业作业',
    primaryFunction: '精密装配', positioning: '工厂精密装配与质量复核',
    features: ['零件定位', '精密装配', '扭矩控制', '视觉质检', '返修标记'],
    scenes: ['电子', '仪器', '小型部件产线'], accentColors: ['钛灰', '工程黄', '橙色']
  }, robotAssemblyScene, robotAssemblySceneMobile, robotAssemblySingle, robotAssemblySingleMobile),
  role({
    slug: 'robot-maintenance', name: '重维', type: 'robot', series: 'Nivi机器人', category: '工业作业',
    primaryFunction: '危险设备检修', positioning: '高温、高压或有毒设备区检修',
    features: ['热点诊断', '阀门操作', '面板拆装', '工具切换', '远程回传'],
    scenes: ['能源站', '化工', '重型工厂'], accentColors: ['钛灰', '工程橙', '黑色']
  }, robotMaintenanceScene, robotMaintenanceSceneMobile, robotMaintenanceSingle, robotMaintenanceSingleMobile),
  role({
    slug: 'robot-breach', name: '烈盾', type: 'robot', series: 'Nivi机器人', category: '公共安全与救援',
    primaryFunction: '消防破拆辅助', positioning: '消防现场的破拆、搬移和通道建立',
    features: ['隔热侦察', '门体破拆', '障碍搬移', '水带牵引', '撤离通道照明'],
    scenes: ['建筑火灾', '事故现场'], accentColors: ['深灰', '消防红', '荧光黄']
  }, robotBreachScene, robotBreachSceneMobile, robotBreachSingle, robotBreachSingleMobile),
  role({
    slug: 'robot-triage', name: '生命站', type: 'robot', series: 'Nivi机器人', category: '公共安全与救援',
    primaryFunction: '现场医疗分诊', positioning: '大规模事件现场的快速医疗分诊辅助',
    features: ['生命体征采集', '伤情分级', '身份登记', '急救物资分发', '医疗信息回传'],
    scenes: ['临时救护点', '灾害现场'], accentColors: ['洁净白', '医疗红', '青色']
  }, robotTriageScene, robotTriageSceneMobile, robotTriageSingle, robotTriageSingleMobile),
  role({
    slug: 'dog-home-guard', name: '宅哨', type: 'dog', series: 'Nivi狗', category: '家庭生活',
    primaryFunction: '住宅安防巡逻', positioning: '住宅内外的自主安全巡逻',
    features: ['周界巡视', '门窗异常检测', '陌生声源定位', '夜视记录', '远程告警'],
    scenes: ['住宅', '社区庭院'], accentColors: ['暖白', '深蓝', '暖金色']
  }, dogHomeGuardScene, dogHomeGuardSceneMobile, dogHomeGuardSingle, dogHomeGuardSingleMobile),
  role({
    slug: 'dog-pace', name: '追风', type: 'dog', series: 'Nivi狗', category: '家庭生活',
    primaryFunction: '户外运动陪练', positioning: '家庭成员户外跑步和骑行陪练',
    features: ['配速引导', '路线记录', '姿态分析', '安全照明', '紧急联络'],
    scenes: ['公园', '绿道'], accentColors: ['暖白', '石墨灰', '红橙色']
  }, dogPaceScene, dogPaceSceneMobile, dogPaceSingle, dogPaceSingleMobile),
  role({
    slug: 'dog-guide', name: '引途', type: 'dog', series: 'Nivi狗', category: '商业服务',
    primaryFunction: '无障碍引导', positioning: '无障碍出行和室内路径引导',
    features: ['路径规划', '障碍识别', '楼梯边缘检测', '触觉引导', '目的地确认'],
    scenes: ['医院', '车站', '商业中心'], accentColors: ['香槟银', '深蓝', '高可视黄']
  }, dogGuideScene, dogGuideSceneMobile, dogGuideSingle, dogGuideSingleMobile),
  role({
    slug: 'dog-delivery', name: '驿行', type: 'dog', series: 'Nivi狗', category: '商业服务',
    primaryFunction: '末端包裹配送', positioning: '商业园区与社区的末端包裹配送',
    features: ['密封载货', '身份核验', '自主导航', '门槛跨越', '签收回传'],
    scenes: ['楼宇', '园区', '社区'], accentColors: ['香槟银', '深蓝', '电光蓝']
  }, dogDeliveryScene, dogDeliverySceneMobile, dogDeliverySingle, dogDeliverySingleMobile),
  role({
    slug: 'dog-leak', name: '管脉', type: 'dog', series: 'Nivi狗', category: '工业作业',
    primaryFunction: '管线泄漏巡检', positioning: '工业管廊的气体、液体与热异常巡检',
    features: ['气体采样', '漏液识别', '热成像', '声学测漏', '位置标记'],
    scenes: ['管廊', '能源站'], accentColors: ['钛灰', '蓝绿色', '黑色']
  }, dogLeakScene, dogLeakSceneMobile, dogLeakSingle, dogLeakSingleMobile),
  role({
    slug: 'dog-haul', name: '载岳', type: 'dog', series: 'Nivi狗', category: '工业作业',
    primaryFunction: '重载物资运输', positioning: '崎岖厂区的重载物资运输',
    features: ['重物承载', '主动调平', '坡道行走', '载荷监测', '编队运输'],
    scenes: ['矿区', '工地', '厂区'], accentColors: ['钛灰', '工程黄', '黑色']
  }, dogHaulScene, dogHaulSceneMobile, dogHaulSingle, dogHaulSingleMobile),
  role({
    slug: 'dog-search', name: '寻生', type: 'dog', series: 'Nivi狗', category: '公共安全与救援',
    primaryFunction: '灾区生命搜索', positioning: '倒塌灾区的生命迹象搜索',
    features: ['热源搜索', '声音放大', '气体生命迹象分析', '缝隙摄像', '位置抛标'],
    scenes: ['地震', '坍塌现场'], accentColors: ['深灰', '紫红色', '荧光黄']
  }, dogSearchScene, dogSearchSceneMobile, dogSearchSingle, dogSearchSingleMobile),
  role({
    slug: 'dog-fire-scout', name: '火瞳', type: 'dog', series: 'Nivi狗', category: '公共安全与救援',
    primaryFunction: '火场环境侦测', positioning: '进入火场进行环境侦测而非破拆',
    features: ['温度测绘', '有毒气体检测', '火源定位', '结构声响监听', '撤离路线回传'],
    scenes: ['火灾', '高温危险区'], accentColors: ['耐火黑', '消防红', '荧光黄']
  }, dogFireScoutScene, dogFireScoutSceneMobile, dogFireScoutSingle, dogFireScoutSingleMobile)
])

export const getSeriesById = id => productSeries.find(series => series.id === id) || null

const robotDisplayOrder = [
  'robot-triage',
  'robot-garment',
  'robot-assembly',
  'robot-care',
  'robot-catering',
  'robot-breach',
  'robot-retail',
  'robot-maintenance'
]

export const getProductsByType = type => {
  const products = roleProducts.filter(product => product.type === type)
  if (type !== 'robot') return products

  return products.sort((left, right) => (
    robotDisplayOrder.indexOf(left.slug) - robotDisplayOrder.indexOf(right.slug)
  ))
}

export const findProduct = (type, slug) => (
  roleProducts.find(product => product.type === type && product.slug === slug) || null
)
